import { createAction, props } from '@ngrx/store';
import { SalesRegion } from '@cemex-core/cmx-api/models/uploads/sales-region';

export const setActive = createAction(
  '[MOO/MODAL/Sales Regions] Set Active Entity',
  props<{ salesRegionId: number | string }>(),
);

export const fetch = createAction(
  '[MOO/MODAL/Sales Regions] Fetch start',
);

export const fetchSuccess = createAction(
  '[MOO/MODAL/Sales Regions] Fetch success',
  props<{ payload: SalesRegion[] }>(),
);

export const fetchFailed = createAction(
  '[MOO/MODAL/Sales Regions] Fetch failed',
);

export const resetSalesRegionsState = createAction(
  '[MOO/MODAL/Sales Regions] Reset State',
);

const SalesRegionsActions = {
  setActive,

  fetch,
  fetchSuccess,
  fetchFailed,

  resetSalesRegionsState,
};

export default SalesRegionsActions;
